module.exports = __webpack_public_path__ + "static/media/defaultLuckyDrawPhoto.3b599bee.png";